import React, { useLayoutEffect } from 'react'
import { isEmpty } from 'libraries/lodash'
import Grid from '@material-ui/core/Grid'
import Error from 'components/shared/Error'
import TileContainer from 'redux/containers/components/tiled-menu/TileContainer'

const TiledMenu = ({ tiledMenu, dataHelpItem, setTiledMenuIsLoaded, ignoreNodes = false, ...props }) => {
  const { rootSections, nodes } = tiledMenu

  useLayoutEffect(() => {
    setTiledMenuIsLoaded(true)
    return () => setTiledMenuIsLoaded(false)
  }, [])
  if (isEmpty(rootSections) || (!ignoreNodes && isEmpty(nodes))) {
    return null
  }

  return (
    <nav>
      {rootSections.length === 0
        ? <Error title='No content' />
        : (
          <div className='tile-container' data-help-item={dataHelpItem} data-help-position='middle'>
            <Grid container spacing={2}>
              {rootSections.map((tile, index) => (
                <Grid key={index} item xs={12} sm={4} md={3} lg={2}>
                  <TileContainer {...{ nodes, ...tile, ...props }} />
                </Grid>
              ))}
            </Grid>
          </div>
          )}
    </nav>
  )
}

export default TiledMenu
